import React from "react";
import {ButtonIconEdit} from "../../../Components/Inputs";
import {HtmlDisplay} from "../../../Components/Display";
import {locations} from "../../../Utilities/Location";
import {
    getCompleteReadingMediumsTextByValue,
    getEligibilityTextByValue,
    getGradeLevelTextByValue,
    getStudentApprovalStatusTextByValue,
} from "../studentUtilities";

interface StudentApprovalRowProps {
    redirect: (path: string) => void;
    student: Record<string, any>;
}

export const StudentApprovalRow: React.FC<StudentApprovalRowProps> = ({redirect, student}) => {


    const handleEditStudentDetailsClick = (event?: React.MouseEvent<HTMLElement>, studentId?: string) => {
        event?.preventDefault();
        if (studentId) redirect(locations.EDIT_STUDENT.getPath(studentId));
    };


    return (
        <tr id={student.studentId} data-testid={student.studentId}>
            <td>
                {student.fullName}
            </td>
            <td>
                {student.fimcStudentId}
            </td>
            <td>
                {student.dateOfBirth}
            </td>
            <td>
                {student.dateCreatedUtc || ``}
            </td>
            <td>
                {student.dateModifiedUtc || ``}
            </td>
            <td>
                {getGradeLevelTextByValue(student.gradeLevel)}
            </td>
            <td>
                {getCompleteReadingMediumsTextByValue(student.primaryReadingMedium)}
            </td>
            <td>
                {student.districtName || ``}
            </td>
            <td>
                {student.userFullName || ``}
            </td>
            <td>
                {student.hasSignedParentalConsentOutput}
            </td>
            <td className={student.studentApprovalStatusName}>
                <HtmlDisplay
                    html={getStudentApprovalStatusTextByValue(student.studentApprovalStatus)}
                    name={`approval-status-${student.studentId}`}/>
            </td>

            <td>
                {getEligibilityTextByValue(student.eligibility || ``)}
            </td>
            <td className={`align-center`}>
                <ButtonIconEdit
                    inputDescription={`for ${student.firstName} ${student.lastName}`}
                    onClick={(event) => handleEditStudentDetailsClick(event, student.studentId)}
                />
            </td>
        </tr>
    );
};